import { NavDropdown } from './NavDropdown';
import { normalizeNavPath } from './navPath';

export const SOLUTION_LINKS = [
  {
    to: '/for-filmmakers',
    label: 'For Filmmakers',
    description: 'Script-first AI filmmaking built for directors',
  },
  {
    to: '/for-agencies',
    label: 'For Agencies',
    description: 'Briefs and scripts to branded films on deadline',
  },
  {
    to: '/for-enterprise',
    label: 'For Enterprise',
    description: 'SSO, workspaces, API, and volume production',
  },
] as const;

type SolutionsNavDropdownProps = {
  pathname: string;
};

function isSolutionsActive(pathname: string) {
  const path = normalizeNavPath(pathname);
  return (
    path === '/for-filmmakers' ||
    path === '/for-agencies' ||
    path === '/for-enterprise'
  );
}

export function isSolutionsNavActive(pathname: string) {
  return isSolutionsActive(pathname);
}

export function SolutionsNavDropdown({ pathname }: SolutionsNavDropdownProps) {
  return (
    <NavDropdown
      label="Solutions"
      links={SOLUTION_LINKS}
      pathname={pathname}
      isActive={isSolutionsActive}
    />
  );
}
